<template>
    <div>
      <h1>Booking Success</h1>
      <MessageClubForm :purchaseId="purchaseId" />
    </div>
  </template>
  
  <script>
  import MessageClubForm from '../components/MessageClubForm.vue';
  
  export default {
    components: {
      MessageClubForm
    },
    data() {
      return {
        purchaseId: '' // This should be fetched from the store or API
      }
    }
  }
  </script>
  